import {
  Popconfirm,
  Col,
  Row,
  Modal,
  Tooltip,
  Empty,
  message,
  Avatar,
  Tabs,
  Table,
  Divider,
  Form,
  Icon,
  Input,
  Button,
  Radio,
  DatePicker,
  PageHeader
} from "antd";
import React, { useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import styles from "./style.module.less";
import * as services from '@/models/tenants/services'
import { connect, useSelector } from "react-redux";
import dayjs from 'dayjs'
import copy from 'copy-to-clipboard';
import { getCurrentUser } from '@/models/user/selectors';
import * as apis from '@/apis'

const AddAccount = Form.create()((props) => {
  const { form, visible, onClose, onSubmit } = props
  const { validateFields, getFieldDecorator } = form;
  const user = useSelector(getCurrentUser);
  let timer = useRef() //验证码定时器
  const [second, setSecond] = useState(60) //倒计时秒数
  const [btnDisabled, setBtnDisabled] = useState(false) //按钮是否可点击，false可点击
  const formItemLayout = {
    labelAlign: 'left',
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
  };
  const initCode = () => {
    clearInterval(timer.current)
    setBtnDisabled(false)
    setSecond(60)
  }
  // 发送验证码，开启倒计时
  const sendCode = () => {
    validateFields(['mobile'], (err, values) => {
      console.log(err, values);
      if (err) {
        return false
      }
      const { mobile } = values
      services.sendCaptcha({ mobile: mobile, type: 'register_company' })
        .then((result) => {
          message.success('验证码发送成功');
          // 倒计时递减
          timer.current = setInterval(() => setSecond((pre) => pre - 1), 1000)
          setBtnDisabled(true)
        })
        .catch((err) => {
          message.error(err?.message || '发送短信验证码失败');
        })
        .finally(() => {
        });
    })
  }

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        // console.log('验证失败', err);
        return false
      }
      services.accountAdd({
        ...values,
        tenantId: user.getIn(['staff', 'tenant', '_id'])
      }).then(res => {
        onSubmit()
        message.success('提交成功');
      }).catch(err => {
        message.error(err?.message || '提交失败');
      })
    });
  };
  useEffect(() => {
    initCode()
    return () => { initCode() }
  }, [])
  // 监听秒数的变动
  useEffect(() => {
    if (second > 0 && second < 60) {
    } else {
      // 定时器超过时间后，可以重新发送验证码
      initCode()
    }
  }, [second])

  return (
    <Modal
      title="添加子账号"
      visible={visible}
      destroyOnClose={true}
      onOk={() => { handleSubmit() }}
      onCancel={() => {
        onClose()
      }}
    >
      <div>
        <Form {...formItemLayout} >
          <Form.Item label="子公司名称">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请输入子公司名称' }],
            })(<Input placeholder="请输入子公司名称" />)}
          </Form.Item>
          <Form.Item label="子企业注册手机">
            <Row gutter={8}>
              <Col span={14}>
                {getFieldDecorator('mobile', {
                  rules: [
                    { required: true, message: '请输入子企业注册手机' },
                    { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号' }
                  ],
                })(
                  <Input placeholder="请输入子企业注册手机" />,
                )}
              </Col>
              <Col span={10}>
                <Button disabled={btnDisabled} type="primary" ghost
                  icon="project" style={{ width: '100%' }}
                  onClick={() => { sendCode() }}>
                  {!btnDisabled ? '获取验证码' : `${second}s后重发`}
                </Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item label="手机短信验证码">
            {getFieldDecorator('code', {
              rules: [{ required: true, message: '请输入手机短信验证码' }],
            })(<Input placeholder="请输入手机短信验证码" />)}
          </Form.Item>

        </Form>
      </div>
    </Modal>
  )
})
const ChangeAccountPassword = Form.create()((props) => {
  const { form, visible, onClose, onSubmit } = props
  const { validateFields, getFieldDecorator } = form;

  const formItemLayout = {
    labelAlign: 'left',
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
  };
  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        // console.log('验证失败', err);
        return false
      }
      services.accountModifyPass({
        ...values,
        id: visible._id
      }).then(res => {
        onSubmit()
        message.success('修改成功');
      }).catch(err => {
        message.error(err?.message || '修改失败');
      })
    });
  };
  useEffect(() => {

    return () => { }
  }, [])


  return (
    <Modal
      title="修改密码"
      visible={!!visible}
      destroyOnClose={true}
      onOk={() => { handleSubmit() }}
      onCancel={() => {
        onClose()
      }}
    >
      <div>
        <Form {...formItemLayout} >
          <Form.Item label="密码">
            {getFieldDecorator('password', {
              rules: [
                { required: true, message: '请输入密码' },
              ],
            })(
              <Input.Password visibilityToggle={true}
                autoComplete="new-password" placeholder="请输入密码" />,
            )}
          </Form.Item>

          <Form.Item label="再次输入密码">
            {getFieldDecorator('password2', {
              rules: [{ required: true, message: '请再次输入密码' }],
            })(<Input.Password visibilityToggle={true}
              autoComplete="new-password" placeholder="请再次输入密码" />)}
          </Form.Item>

        </Form>
      </div>
    </Modal>
  )
})

const Account = (props) => {
  const user = useSelector(getCurrentUser);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [changePasswordRow, setChangePasswordRow] = useState(null);

  const columns = [
    {
      title: '序号',
      key: '_id',
      width: 60,
      align: 'center',
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    // {
    //   title: '登录账号',
    //   width: 200,
    //   key: 'name',
    //   dataIndex: 'name',
    //   render: (text, record, idx) => <span>{record?.user?.mobile}</span>
    // },
    // {
    //   title: '账号名称',
    //   width: 160,
    //   align: 'center',
    //   key: 'cur_num',
    //   dataIndex: 'cur_num',
    // },
    {
      title: '子公司名称',
      width: 160,
      align: 'center',
      key: 'cancel_num',
      // dataIndex: 'cancel_num',
      render: (text, record, idx) => {
        return (
          <>
            <a disabled={user.getIn(['staff',['account_type']]) != 1} onClick={() => {
              apis.exchangeAccount({ tenantId: record._id, origin: 0 })
                .then(() => {
                  message.success('账号切换成功')
                  setTimeout(() => {
                    location.reload()
                  }, 600);
                })
                .catch(error => {
                  message.error(error.message || '调用异常')
                })
            }}>{record?.name}</a>
            {/* <a onClick={() => {
              // copy(record?.tenant_no);
              // message.success("复制成功")
            }}>复制</a> */}
          </>
        )
      }
    },
    {
      title: '企业注册代码',
      width: 160,
      align: 'center',
      key: 'cancel_percent',
      // dataIndex: 'cancel_percent',
      render: (text, record, idx) => {
        return (
          <>{record?.tenant_no}
            <a onClick={() => {
              copy(record?.tenant_no);
              message.success("复制成功")
            }}>复制</a>
          </>
        )
      }
    },
    // {
    //   title: '账号类型',
    //   width: 160,
    //   align: 'center',
    //   key: 'avg_price',
    //   dataIndex: 'avg_price',
    //   render: (text, record, idx) => {
    //     return (
    //       <>
    //         {record?.account_type == 1 && <span>企业管理员</span>}
    //         {record?.account_type == 2 && <span>子账号</span>}
    //       </>
    //     )
    //   }
    // },
    {
      title: '注册时间',
      width: 160,
      align: 'center',
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: (text, record, idx) => {
        return (
          <>
            <span>{dayjs(record.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
          </>
        )
      }
    },
    {
      title: '操作',
      key: 'action',
      width: 260,
      fixed: 'right',
      render: (text, record) => (
        <span>
          {/* <a onClick={() => {
            setChangePasswordRow(record)
          }}>修改密码</a>
          <Divider type="vertical" /> */}
          <Popconfirm
            placement="topRight"
            title="确认解除关系？"
            onConfirm={() => { deleteAccount(record) }}
          >
            <a>解除关系</a>
          </Popconfirm>

          {/* {record?.account_type == 2 && <>
            <Divider type="vertical" />
            <Popconfirm
              placement="topRight"
              title="确认转让管理员？"
              onConfirm={() => { changeAdmin(record) }}
            >
              <a>转让管理员</a>
            </Popconfirm>
          </>} */}
        </span>
      ),
    },
  ]
  const deleteAccount = (row) => {
    services.accountDel({
      id: row._id
    }).then(res => {
      searchData()
      message.success('解除成功');
    }).catch(err => {
      message.error(err?.message || '解除失败');
    })
  };

  const changeAdmin = (row) => {
    services.changeAdmin({
      cstaffId: row._id
    }).then(res => {
      searchData()
      message.success('转让成功');
    }).catch(err => {
      message.error(err?.message || '转让失败');
    })
  };

  const fetchList = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)

    services
      .getAccountList(params)
      .then((data) => {
        setItems(data.accountList || [])
        setTotal(data.total || 0)
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [])
  const handleTableChange = (pagination, filters, sorter) => {

    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }
    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetchList(nextQuery)
  }
  const searchData = () => {
    let offset = 0
    let limit = 10
    fetchList({ offset, limit })
  }
  useEffect(() => {
    fetchList()
    return () => { }
  }, [])

  return (
    <>
      <div className={styles.blockstyle}>
        <PageHeader
          style={{
            padding: '0 10px 20px',
          }}
          title="子账号管理"
          extra={[
            <Button key="1" type="primary" onClick={() => {
              setVisibleModal(true)
            }}>
              添加子账号
            </Button>,

          ]}
        />

        <div>
          <Table
            rowKey="name"
            size="middle"
            columns={columns}
            dataSource={items}
            onChange={handleTableChange}
            loading={loading}
            scroll={{ x: '100%' }}
            pagination={{
              showQuickJumper: true,
              total: total,
              pageSize: +limit,
              current: Math.floor(offset / +limit) + 1,
              showTotal: total => `共 ${total} 条`
            }}
          ></Table>
        </div>
      </div>
      <AddAccount visible={visibleModal}
        onClose={() => { setVisibleModal(false) }}
        onSubmit={() => {
          setVisibleModal(false);
          searchData()
        }}
      />
      <ChangeAccountPassword visible={changePasswordRow}
        onClose={() => { setChangePasswordRow(null) }}
        onSubmit={() => {
          setChangePasswordRow(null);
          searchData()
        }}
      />
    </>
  );

}

export default connect()(Form.create()(Account));
